import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { useAsyncThrow } from './useAsyncThrow';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import type { PolicyPeriodStatus } from 'gw-edge-client/dist/types/dto/pc/typekey';

const RETRY_TIMEOUT = 3000;
const MAX_RETRIES = (3 * 60 * 1000) / RETRY_TIMEOUT;

const wait = async (duration: number): Promise<void> => {
    await new Promise((resolve) => setTimeout(resolve, duration));
};

export function useAwaitQuoteJob(): {
    awaitQuoteJob: () => Promise<void>;
} {
    const { asyncThrow } = useAsyncThrow<PolicyPeriodStatus>();
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const awaitQuoteJob = async (): Promise<void> => {
        let retries = 0;
        let status = await OnlineSales.getJobStatus(jobNumber, sessionId).catch(asyncThrow);

        while (status !== 'Quoted' && retries < MAX_RETRIES) {
            switch (status) {
                case 'Quoting':
                    await wait(RETRY_TIMEOUT);
                    status = await OnlineSales.getJobStatus(jobNumber, sessionId).catch(asyncThrow);
                    break;
                default:
                    asyncThrow(new Error(`Returned unexpected status of ${status ?? ''}.`));
                    break;
            }
            retries += 1;
        }
        if (retries === MAX_RETRIES)
            asyncThrow(new Error('Exceeded max retries for awaitQuoteJob.'));
    };

    return { awaitQuoteJob };
}
